module.exports = __webpack_public_path__ + "img/mainframe-computer-server.15dc9d2f.png";